// constants
import { ACCESSIBILITY_TEXTS, MOST_POPULAR_TEXT } from "../constants/AmountBox";

// utils
import { format } from "../utils/String";

export function isEmpty<T>(
    value: T | string | number | boolean | undefined | null,
): value is "" | undefined | null | false | 0 {
    switch (typeof value) {
        case "string":
            return value.length === 0;
        case "number":
        case "boolean":
            return !value;
        case "undefined":
            return true;
        case "object":
            return value === null || Object.keys(value).length === 0 ? true : false; // handling for null.
        case "function":
            return false;
        default:
            return !value ? true : false;
    }
}

export const getFixedNotationIfNotInteger = (value: number, toFix?: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(toFix || 2);
};

export const checkIfNumber = (param: string): boolean => {
    if (param == null || param == "") {
        return false;
    }
    const value = Number(param);

    return !Number.isNaN(value);
};

export const isWebPlatform = (platform: string): boolean => {
    if (isEmpty(platform)) return false;
    const _platform = platform.toLowerCase();
    return ["swiggy-mweb", "swiggy-dweb", "mweb", "dweb"].includes(_platform);
};
export const isMWebPlatform = (platform: string): boolean => {
    if (isEmpty(platform)) return false;
    const _platform = platform?.toLowerCase();
    return _platform === "mweb";
};

export const isiOSPlatform = (platform: string): boolean => {
    if (isEmpty(platform)) return false;
    const _platform = platform.toLowerCase();
    return _platform === "swiggy-ios" || _platform === "ios";
};

export const isAndroidPlatform = (platform: string): boolean => {
    if (isEmpty(platform)) return false;
    const _platform = platform.toLowerCase();
    return _platform === "swiggy-android" || _platform === "an";
};

export const isAppPlatform = (platform: string): boolean => {
    return isiOSPlatform(platform) || isAndroidPlatform(platform);
};

export const isVersionCodeEligible = (
    minAndroidVersion = 973,
    minIosVersion = 380,
    versionCode?: string,
    platform?: string,
): boolean => {
    if (isEmpty(platform) || isEmpty(versionCode) || isNaN(Number(versionCode))) {
        return false;
    }
    if (isAndroidPlatform(platform as string)) {
        return minAndroidVersion ? Number(versionCode) >= minAndroidVersion : true;
    }
    if (isiOSPlatform(platform as string)) {
        return minIosVersion ? Number(versionCode) >= minIosVersion : true;
    }
    return false;
};

export const getAmountBoxAriaLabel = (amount: string, selected: boolean, showMostPopularText: boolean): string => {
    let ariaLabel = format(ACCESSIBILITY_TEXTS.AMOUNT_BOX_RUPEE, amount);
    if (selected) ariaLabel = ariaLabel.concat(" ", ACCESSIBILITY_TEXTS.IS_SELECTED);
    if (showMostPopularText) ariaLabel = ariaLabel.concat(", ", MOST_POPULAR_TEXT);

    return ariaLabel;
};

export const convertObjToString = (_object: unknown): string => {
    try {
        return JSON.stringify(_object);
    } catch (_ex) {
        return "";
    }
};

export const isDateWithinInterval = (date: Date, start: Date, end: Date): boolean => {
    return date >= start && date <= end;
};

export function isValidNumber(value?: number | string): boolean {
    if (typeof value === "number" && isFinite(value)) {
        return true; // Already a valid number
    }
    if (typeof value === "string" && value.trim() !== "") {
        return isFinite(Number(value));
    }
    return false;
}
